export const diffi=[
  {
    "NAME": "Blasia pusilla",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Lunularia cruciata",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Marchantia polymorpha",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Pleurozia purpurea",
    "DIFF": 1,
    "NOTES": "Very easy ('purple worms'), but restricted to hyperoceanic areas."
  },
  {
    "NAME": "Metzgeria furcata",
    "DIFF": 1,
    "NOTES": "But beware poorly-developed forms of other Metzgeria spp."
  },
  {
    "NAME": "Metzgeria pubescens",
    "DIFF": 1,
    "NOTES": "Rather rare, but very distinctive, hairy all over."
  },
  {
    "NAME": "Aneura pinguis",
    "DIFF": 1,
    "NOTES": "Dark green, 'greasy' appearance gives plant a distinctive jiz."
  },
  {
    "NAME": "Aneura mirabilis",
    "DIFF": 1,
    "NOTES": "Rare and little-recorded, but unmistakable, like a subterranean white A. pinguis."
  },
  {
    "NAME": "Radula complanata",
    "DIFF": 1,
    "NOTES": "But beware R. lindenbergiana."
  },
  {
    "NAME": "Bazzania trilobata",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Lepidozia reptans",
    "DIFF": 1,
    "NOTES": "Common on tree stumps etc."
  },
  {
    "NAME": "Lophocolea bidentata",
    "DIFF": 1,
    "NOTES": "Almost ubiquitous, our commonest liverwort."
  },
  {
    "NAME": "Gymnomitrion concinnatum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Diplophyllum albicans",
    "DIFF": 1,
    "NOTES": "Very common in non-base-rich places."
  },
  {
    "NAME": "Tetraphis pellucida",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Tetrodontium brownianum",
    "DIFF": 1,
    "NOTES": "But uncommon, so rarely seen."
  },
  {
    "NAME": "Atrichum undulatum",
    "DIFF": 1,
    "NOTES": "Beware juvenile plants which are hardly undulate and may be confused with rarer Atrichum spp."
  },
  {
    "NAME": "Oligotrichum hercynicum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Pogonatum aloides",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Pogonatum urnigerum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Polytrichum formosum",
    "DIFF": 1,
    "NOTES": "Usually straightforward in dry woodland but beware P. pergoniale and stunted P. commune elsewhere."
  },
  {
    "NAME": "Polytrichum commune",
    "DIFF": 1,
    "NOTES": "Typical plants in wet ground straightforward."
  },
  {
    "NAME": "Polytrichum piliferum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Polytrichum juniperinum",
    "DIFF": 1,
    "NOTES": "Beware stunted forms of P. formosum, which have toothed leaf margins."
  },
  {
    "NAME": "Diphyscium foliosum",
    "DIFF": 1,
    "NOTES": "Unmistakable when capsules present; its thick opaque leaves are also distinctive."
  },
  {
    "NAME": "Encalypta vulgaris",
    "DIFF": 1,
    "NOTES": "Easy when capsules are present."
  },
  {
    "NAME": "Funaria hygrometrica",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Physcomitrium pyriforme",
    "DIFF": 1,
    "NOTES": "When capsules are present."
  },
  {
    "NAME": "Physcomitrium patens",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Flexitrichum gracile",
    "DIFF": 1,
    "NOTES": "When plants are well-grown."
  },
  {
    "NAME": "Campylopus atrovirens",
    "DIFF": 1,
    "NOTES": "Typical blackish upland plants are straightforward. Forma falcatus has strongly falcate leaves."
  },
  {
    "NAME": "Campylopus introflexus",
    "DIFF": 1,
    "NOTES": "Forms with well-developed hairpoints are straightforward but hairpoints can be very short."
  },
  {
    "NAME": "Leucobryum glaucum",
    "DIFF": 1,
    "NOTES": "Large hummocks in bogs and open habitats easy to recognise. Small growth forms may be confused with L. juniperoideum."
  },
  {
    "NAME": "Dichodontium palustre",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Dicranella heteromalla",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens incurvus",
    "DIFF": 1,
    "NOTES": "Only straightforward when mature capsules are present."
  },
  {
    "NAME": "Dicranum majus",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Schistostega pennata",
    "DIFF": 1,
    "NOTES": "Goblin's-gold'. Unmistakable."
  },
  {
    "NAME": "Pseudephemerum nitidum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Tortella nitida",
    "DIFF": 1,
    "NOTES": "Forms cushions with characteristically broken leaf tips in coastal areas."
  },
  {
    "NAME": "Dialytrichia mucronata",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Pseudocrossidium revolutum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Tortula muralis",
    "DIFF": 1,
    "NOTES": "Very common species of walltops etc."
  },
  {
    "NAME": "Tortula truncata",
    "DIFF": 1,
    "NOTES": "Mature capsules are unmistakable; developing urns are longer and may resemble T. truncata."
  },
  {
    "NAME": "Tortula acaulon",
    "DIFF": 1,
    "NOTES": "Very common."
  },
  {
    "NAME": "Microbryum rectum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Microbryum curvicollum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Hennediella heimii",
    "DIFF": 1,
    "NOTES": "If mature capsules are present."
  },
  {
    "NAME": "Syntrichia papillosa",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Syntrichia latifolia",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Cinclidotus fontinaloides",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia pulvinata",
    "DIFF": 1,
    "NOTES": "Ubiquitous on walls etc. in the lowlands."
  },
  {
    "NAME": "Racomitrium aciculare",
    "DIFF": 1,
    "NOTES": "Very common in watercourses in N and W."
  },
  {
    "NAME": "Racomitrium lanuginosum",
    "DIFF": 1,
    "NOTES": "Ubiquitous in the uplands."
  },
  {
    "NAME": "Plagiopus oederianus",
    "DIFF": 1,
    "NOTES": "Plants with capsules in base-rich habitats easy to recognise."
  },
  {
    "NAME": "Bartramia halleriana",
    "DIFF": 1,
    "NOTES": "Only straightforward when capsules are present."
  },
  {
    "NAME": "Philonotis fontana",
    "DIFF": 1,
    "NOTES": "Commonest species, rather variable."
  },
  {
    "NAME": "Breutelia chrysocoma",
    "DIFF": 1,
    "NOTES": "Common in uplands where there is a little base."
  },
  {
    "NAME": "Bryum argenteum",
    "DIFF": 1,
    "NOTES": "Ubiquitous silvery species of urban habitats."
  },
  {
    "NAME": "Bryum dichotomum",
    "DIFF": 1,
    "NOTES": "Ubiquitous - may have capsules and bulbils."
  },
  {
    "NAME": "Bryum capillare",
    "DIFF": 1,
    "NOTES": "Ubiquitous."
  },
  {
    "NAME": "Bryum pseudotriquetrum",
    "DIFF": 1,
    "NOTES": "Very variable species but robust forms in wet habitats are straightforward."
  },
  {
    "NAME": "Rhodobryum roseum",
    "DIFF": 1,
    "NOTES": "Unmistakable."
  },
  {
    "NAME": "Mnium hornum",
    "DIFF": 1,
    "NOTES": "Ubiquitous in acid habitats."
  },
  {
    "NAME": "Rhizomnium punctatum",
    "DIFF": 1,
    "NOTES": "Very common and distinctive."
  },
  {
    "NAME": "Plagiomnium undulatum",
    "DIFF": 1,
    "NOTES": "Very common woodland plant - mature plants are straightforward."
  },
  {
    "NAME": "Orthotrichum anomalum",
    "DIFF": 1,
    "NOTES": "Commonest species on stone/rock."
  },
  {
    "NAME": "Orthotrichum diaphanum",
    "DIFF": 1,
    "NOTES": "Hyaline hair points set it apart."
  },
  {
    "NAME": "Lewinskya striata",
    "DIFF": 1,
    "NOTES": "Straightforward when mature capsules present."
  },
  {
    "NAME": "Plenogemma phyllantha",
    "DIFF": 1,
    "NOTES": "Spreading inland from coastal habitats."
  },
  {
    "NAME": "Pulvigera lyellii",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Aulacomnium palustre",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Aulacomnium androgynum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Hookeria lucens",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Fontinalis antipyretica",
    "DIFF": 1,
    "NOTES": "Very variable but typical, robust forms are straightforward."
  },
  {
    "NAME": "Orthothecium rufescens",
    "DIFF": 1,
    "NOTES": "Robust red forms are easily recognised."
  },
  {
    "NAME": "Plagiothecium undulatum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Climacium dendroides",
    "DIFF": 1,
    "NOTES": "Well-branched forms are unmistakable."
  },
  {
    "NAME": "Cratoneuron filicinum",
    "DIFF": 1,
    "NOTES": "Common and extremely variable; atypical growth forms may be difficult."
  },
  {
    "NAME": "Palustriella commutata",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Amblystegium serpens",
    "DIFF": 1,
    "NOTES": "Very variable - very slender forms may resemble rarer threadlike pleurocarps."
  },
  {
    "NAME": "Scorpidium scorpioides",
    "DIFF": 1,
    "NOTES": "Dark colour and swollen-looking shoots are normally characteristic."
  },
  {
    "NAME": "Thuidium tamariscinum",
    "DIFF": 1,
    "NOTES": "Typical woodland plants are straightforward."
  },
  {
    "NAME": "Pseudoscleropodium purum",
    "DIFF": 1,
    "NOTES": "Very common."
  },
  {
    "NAME": "Eurhynchium striatum",
    "DIFF": 1,
    "NOTES": "Very common woodland plant."
  },
  {
    "NAME": "Cirriphyllum piliferum",
    "DIFF": 1,
    "NOTES": "Unmistakable leaf shape."
  },
  {
    "NAME": "Kindbergia praelonga",
    "DIFF": 1,
    "NOTES": "Ubiquitous but variable. Leaf dimorphism is good character."
  },
  {
    "NAME": "Brachythecium albicans",
    "DIFF": 1,
    "NOTES": "Variable, but typical sandy ground forms are straightforward."
  },
  {
    "NAME": "Calliergonella cuspidata",
    "DIFF": 1,
    "NOTES": "Ubiquitous in all kinds of basic lowland habitats."
  },
  {
    "NAME": "Ptilium crista-castrensis",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Pleurozium schreberi",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Rhytidiadelphus squarrosus",
    "DIFF": 1,
    "NOTES": "In many lawns."
  },
  {
    "NAME": "Rhytidiadelphus loreus",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Hylocomiadelphus triquetrus",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Hylocomium splendens",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Rhytidium rugosum",
    "DIFF": 1,
    "NOTES": "Like a large Hypnum with undulate leaves."
  },
  {
    "NAME": "Cryphaea heteromalla",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Neckera crispa",
    "DIFF": 1,
    "NOTES": "Mostly rock-dwelling but epiphytic in a few areas."
  },
  {
    "NAME": "Ctenidium molluscum",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Myurium hochstetteri",
    "DIFF": 1,
    "NOTES": "Unmistakable but confined to NW Scotland and islands."
  },
  {
    "NAME": "Anomodon viticulosus",
    "DIFF": 1,
    "NOTES": ""
  },
  {
    "NAME": "Haplomitrium hookeri",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Marchantia polymorpha subsp. polymorpha",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Marchantia polymorpha subsp. ruderalis",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Marchantia polymorpha subsp. montivagans",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Marchantia quadrata",
    "DIFF": 2,
    "NOTES": "Marchantia quadrata and Reboulia hemisphaerica can be a troublesome pair until one is used to them."
  },
  {
    "NAME": "Targionia hypophylla",
    "DIFF": 2,
    "NOTES": "Easy but rather rare."
  },
  {
    "NAME": "Conocephalum conicum",
    "DIFF": 2,
    "NOTES": "Conocephalum sens. lat. easy to identify."
  },
  {
    "NAME": "Conocephalum salebrosum",
    "DIFF": 2,
    "NOTES": "Conocephalum sens. lat. easy to identify."
  },
  {
    "NAME": "Riccia sorocarpa",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Ricciocarpos natans",
    "DIFF": 2,
    "NOTES": "Easy but rather uncommon."
  },
  {
    "NAME": "Pellia epiphylla",
    "DIFF": 2,
    "NOTES": "But beware sterile material: sterile Pellia can be very difficult to identify to species."
  },
  {
    "NAME": "Pellia endiviifolia",
    "DIFF": 2,
    "NOTES": "Easy in the autumn with the calabrese-like branching."
  },
  {
    "NAME": "Pallavicinia lyellii",
    "DIFF": 2,
    "NOTES": "Rare."
  },
  {
    "NAME": "Metzgeria violacea",
    "DIFF": 2,
    "NOTES": "Providing good gemmae are present."
  },
  {
    "NAME": "Metzgeria consanguinea",
    "DIFF": 2,
    "NOTES": "Providing good gemmae are present."
  },
  {
    "NAME": "Metzgeria leptoneura",
    "DIFF": 2,
    "NOTES": "Distinctive hooked marginal hairs."
  },
  {
    "NAME": "Riccardia palmata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Riccardia latifrons",
    "DIFF": 2,
    "NOTES": "Distinctive 'splayed' thalli, usually in bogs."
  },
  {
    "NAME": "Porella arboris-vitae",
    "DIFF": 2,
    "NOTES": "But microscopic examination may be necessary in some cases."
  },
  {
    "NAME": "Porella obtusata",
    "DIFF": 2,
    "NOTES": "But microscopic examination may be necessary in some cases."
  },
  {
    "NAME": "Frullania tamarisci",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Frullania teneriffae",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Frullania dilatata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Colura calyptrifolia",
    "DIFF": 2,
    "NOTES": "Very small but very distinctive."
  },
  {
    "NAME": "Ptilidium ciliare",
    "DIFF": 2,
    "NOTES": "Ptilidium easy to identify, but the species less so; P. ciliare a common plant of heathland."
  },
  {
    "NAME": "Blepharostoma trichophyllum",
    "DIFF": 2,
    "NOTES": "Check microscopically until familiar."
  },
  {
    "NAME": "Mastigophora woodsii",
    "DIFF": 2,
    "NOTES": "Easy but rare and hyperoceanic."
  },
  {
    "NAME": "Herbertus stramineus",
    "DIFF": 2,
    "NOTES": "Need to be able to recognise the jiz in the field, which is more helpful than microscopic examination."
  },
  {
    "NAME": "Herbertus hutchinsiae",
    "DIFF": 2,
    "NOTES": "Need to be able to recognise the jiz in the field, which is more helpful than microscopic examination."
  },
  {
    "NAME": "Herbertus borealis",
    "DIFF": 2,
    "NOTES": "Need to be able to recognise the jiz in the field, which is more helpful than microscopic examination; very rare but locally abundant at one locality in Scotland."
  },
  {
    "NAME": "Bazzania tricrenata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Lepidozia cupressina",
    "DIFF": 2,
    "NOTES": "Rather rare but very distinctive."
  },
  {
    "NAME": "Trichocolea tomentella",
    "DIFF": 2,
    "NOTES": "Not very common but very distinctive."
  },
  {
    "NAME": "Lophocolea heterophylla",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Plagiochila carringtonii",
    "DIFF": 2,
    "NOTES": "Easy but rare and hyperoceanic."
  },
  {
    "NAME": "Plagiochila porelloides",
    "DIFF": 2,
    "NOTES": "Common and eay but check P. asplenioides until familiar."
  },
  {
    "NAME": "Plagiochila asplenioides",
    "DIFF": 2,
    "NOTES": "Common and easy; about twice the size of P. porelloides."
  },
  {
    "NAME": "Plagiochila spinulosa",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Plagiochila punctata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Calypogeia fissa",
    "DIFF": 2,
    "NOTES": "The commonest Calypogeia."
  },
  {
    "NAME": "Calypogeia muelleriana",
    "DIFF": 2,
    "NOTES": "The second commonest Calypogeia."
  },
  {
    "NAME": "Calypogeia arguta",
    "DIFF": 2,
    "NOTES": "The third commonest Calypogeia."
  },
  {
    "NAME": "Saccogyna viticulosa",
    "DIFF": 2,
    "NOTES": "Oceanic areas only."
  },
  {
    "NAME": "Nardia compressa",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Nardia scalaris",
    "DIFF": 2,
    "NOTES": "Very common and easy in field knce known."
  },
  {
    "NAME": "Gymnomitrion obtusum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Gymnomitrion crenulatum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Marsupella emarginata",
    "DIFF": 2,
    "NOTES": "Very common in many areas, soon known in the field."
  },
  {
    "NAME": "Pseudomarsupidium decipiens",
    "DIFF": 2,
    "NOTES": "Oceanic areas only."
  },
  {
    "NAME": "Cephalozia bicuspidata",
    "DIFF": 2,
    "NOTES": "The commonest Cephalozia."
  },
  {
    "NAME": "Cephalozia curvifolia",
    "DIFF": 2,
    "NOTES": "Very distinctive plant of rotting logs and sometimes peat surfaces."
  },
  {
    "NAME": "Odontoschisma sphagni",
    "DIFF": 2,
    "NOTES": "The most conspicuous 'bog liverwort'"
  },
  {
    "NAME": "Odontoschisma denudatum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Anastrophyllum donnianum",
    "DIFF": 2,
    "NOTES": "Rare and oceanic, but big and easy."
  },
  {
    "NAME": "Sphenolobus minutus",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Gymnocolea inflata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Orthocaulis floerkei",
    "DIFF": 2,
    "NOTES": "The commonest 'Barbilophozia' ini most areas."
  },
  {
    "NAME": "Orthocaulis attenuatus",
    "DIFF": 2,
    "NOTES": "Distinctive attenuate shoots."
  },
  {
    "NAME": "Anastrepta orcadensis",
    "DIFF": 2,
    "NOTES": "Easy and large, oceanic."
  },
  {
    "NAME": "Tetralophozia setiformis",
    "DIFF": 2,
    "NOTES": "Easy and large, rather rare."
  },
  {
    "NAME": "Barbilophozia barbata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Lophozia ventricosa",
    "DIFF": 2,
    "NOTES": "The commonest Lophozia; but very variable, and the distinction between this and some of the rarer Lophozias is obscure and difficult - their taxonomy is still very much under discussion."
  },
  {
    "NAME": "Tritomaria quinquedentata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Schistochilopsis incisa",
    "DIFF": 2,
    "NOTES": "But high altitude material may require microscopic examination to distinguish from L. opacifolia."
  },
  {
    "NAME": "Douinia ovata",
    "DIFF": 2,
    "NOTES": "Uncommon but distinctive."
  },
  {
    "NAME": "Scapania umbrosa",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Scapania nemorea",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Scapania undulata",
    "DIFF": 2,
    "NOTES": "Very common aquatic species."
  },
  {
    "NAME": "Scapania gracilis",
    "DIFF": 2,
    "NOTES": "Very common in oceanic areas."
  },
  {
    "NAME": "Scapania ornithopoides",
    "DIFF": 2,
    "NOTES": "Oceanic and rather rare, but large and distinctive."
  },
  {
    "NAME": "Scapania nimbosa",
    "DIFF": 2,
    "NOTES": "Oceanic and rather rare, but large and distinctive."
  },
  {
    "NAME": "Mylia taylorii",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Mylia anomala",
    "DIFF": 2,
    "NOTES": "Common in bogs, but beware the even commoner Odontoschisma sphagni."
  },
  {
    "NAME": "Sphagnum palustre",
    "DIFF": 2,
    "NOTES": "Forms with squarrose branch leaves may resemble S. squarrosum."
  },
  {
    "NAME": "Sphagnum squarrosum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum fimbriatum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum girgensohnii",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum capillifolium",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum rubellum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum tenellum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum cuspidatum",
    "DIFF": 2,
    "NOTES": "Terrestrial forms can resemble S. fallax."
  },
  {
    "NAME": "Andreaea rupestris",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Polytrichum strictum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Buxbaumia aphylla",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Buxbaumia viridis",
    "DIFF": 2,
    "NOTES": "Rarer than B. aphylla."
  },
  {
    "NAME": "Encalypta streptocarpa",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Encalypta ciliata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Entosthodon attenuatus",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Discelium nudum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Distichium capillaceum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Amphidium mougeotii",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Dicranella varia",
    "DIFF": 2,
    "NOTES": "Stiff-leaved forms should be checked for D. howei."
  },
  {
    "NAME": "Dicranella rufescens",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Dicranella cerviculata",
    "DIFF": 2,
    "NOTES": "Only easy when capsules present."
  },
  {
    "NAME": "Fissidens bryoides var. bryoides",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens celticus",
    "DIFF": 2,
    "NOTES": "Small erect plants with numerous pairs of leaves and a bent costa."
  },
  {
    "NAME": "Fissidens osmundoides",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens taxifolius",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens polyphyllus",
    "DIFF": 2,
    "NOTES": "Rare plant but usually very distinctive."
  },
  {
    "NAME": "Fissidens fontanus",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Dicranum bonjeanii",
    "DIFF": 2,
    "NOTES": "Plants with strongly undulate leaf tips are straightforward. D. scoparium can have weakly undulate tips."
  },
  {
    "NAME": "Dicranum scoparium",
    "DIFF": 2,
    "NOTES": "The commonest Dicranum."
  },
  {
    "NAME": "Dicranum tauricum",
    "DIFF": 2,
    "NOTES": "Usually easily recognised."
  },
  {
    "NAME": "Dicranoweisia cirrata",
    "DIFF": 2,
    "NOTES": "Common in a range of lowland acid habitats."
  },
  {
    "NAME": "Arctoa fulvella",
    "DIFF": 2,
    "NOTES": "Only straightforward to identify when mature capsules present."
  },
  {
    "NAME": "Trichodon cylindricus",
    "DIFF": 2,
    "NOTES": "May sometimes resemble Dicranella schreberiana."
  },
  {
    "NAME": "Ceratodon purpureus",
    "DIFF": 2,
    "NOTES": "Very common but somewhat anonymous without capsules."
  },
  {
    "NAME": "Weissia controversa var. controversa",
    "DIFF": 2,
    "NOTES": "Commonest species."
  },
  {
    "NAME": "Trichostomum crispulum",
    "DIFF": 2,
    "NOTES": "Highly variable - some forms can be difficult."
  },
  {
    "NAME": "Tortella squarrosa",
    "DIFF": 2,
    "NOTES": "Most common in coastal areas."
  },
  {
    "NAME": "Tortella tortuosa",
    "DIFF": 2,
    "NOTES": "Common species on limestone."
  },
  {
    "NAME": "Chionoloma tenuirostre",
    "DIFF": 2,
    "NOTES": "Common close to water in N and W."
  },
  {
    "NAME": "Anoectangium aestivum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Gymnostomum viridulum",
    "DIFF": 2,
    "NOTES": "Tiny, vivid green plants with short blunt leaves."
  },
  {
    "NAME": "Gymnostomum aeruginosum",
    "DIFF": 2,
    "NOTES": "Very variable."
  },
  {
    "NAME": "Pseudocrossidium hornschuchianum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Bryoerythrophyllum recurvirostrum",
    "DIFF": 2,
    "NOTES": "Well-coloured forms are straightforward."
  },
  {
    "NAME": "Leptodontium gemmascens",
    "DIFF": 2,
    "NOTES": "When gemmiferous and on thatch, unmistakable."
  },
  {
    "NAME": "Streblotrichum convolutum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Streblotrichum convolutum var. convolutum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Streblotrichum convolutum var. commutatum",
    "DIFF": 2,
    "NOTES": "Often approaching B. unguiculata in size, with markedly wavy leaves."
  },
  {
    "NAME": "Barbula unguiculata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Didymodon sinuosus",
    "DIFF": 2,
    "NOTES": "Not always fragile-leaved. Teeth at leaf tips and barely recurved leaves are important characters."
  },
  {
    "NAME": "Didymodon fallax",
    "DIFF": 2,
    "NOTES": "Common plant but over-recorded for D. vinealis and D. insulanus."
  },
  {
    "NAME": "Didymodon luridus",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Didymodon tophaceus",
    "DIFF": 2,
    "NOTES": "Highly variable plant."
  },
  {
    "NAME": "Didymodon nicholsonii",
    "DIFF": 2,
    "NOTES": "Now abundant in many districts on tarmac."
  },
  {
    "NAME": "Didymodon insulanus",
    "DIFF": 2,
    "NOTES": "Typical forms are straightforward but confusion is possible with D. fallax and D. vinealis."
  },
  {
    "NAME": "Aloina aloides",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Tortula subulata",
    "DIFF": 2,
    "NOTES": "Quite common."
  },
  {
    "NAME": "Syntrichia ruralis var. ruralis",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Syntrichia ruraliformis",
    "DIFF": 2,
    "NOTES": "Mostly coastal but apparently increasing inland."
  },
  {
    "NAME": "Syntrichia montana",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Syntrichia laevipila",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Blindia acuta",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Blindiadelphus recurvatus",
    "DIFF": 2,
    "NOTES": "The commonest species with a curved seta."
  },
  {
    "NAME": "Seligeria donniana",
    "DIFF": 2,
    "NOTES": "Mature capsules essential for certain ID."
  },
  {
    "NAME": "Ptychomitrium polyphyllum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium maritimum",
    "DIFF": 2,
    "NOTES": "Plants with capsules are straightforward."
  },
  {
    "NAME": "Schistidium rivulare",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium crassipilum",
    "DIFF": 2,
    "NOTES": "Very common plant in lowlands and the only Schistidium in many areas."
  },
  {
    "NAME": "Grimmia donniana",
    "DIFF": 2,
    "NOTES": "Common in upland areas and distinctive when capsules are present."
  },
  {
    "NAME": "Grimmia trichophylla",
    "DIFF": 2,
    "NOTES": "Common in acid uplands."
  },
  {
    "NAME": "Grimmia hartmanii",
    "DIFF": 2,
    "NOTES": "Distinctive species with curved leaves and brown raspberry-like gemmae at shoot tips."
  },
  {
    "NAME": "Racomitrium aquaticum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Racomitrium fasciculare",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Hedwigia stellata",
    "DIFF": 2,
    "NOTES": "Common in upland districts."
  },
  {
    "NAME": "Tetraplodon angustatus",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Tetraplodon mnioides",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Splachnum sphaericum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Splachnum ampullaceum",
    "DIFF": 2,
    "NOTES": "Commonest species in uplands."
  },
  {
    "NAME": "Leptobryum pyriforme",
    "DIFF": 2,
    "NOTES": "Straightforward when capsules present; rather anonymous otherwise."
  },
  {
    "NAME": "Bartramia pomiformis",
    "DIFF": 2,
    "NOTES": "Not to be confused with B. ithyphylla."
  },
  {
    "NAME": "Bartramia ithyphylla",
    "DIFF": 2,
    "NOTES": "Not to be confused with B. pomiformis."
  },
  {
    "NAME": "Philonotis calcarea",
    "DIFF": 2,
    "NOTES": "Robust, falcate-leaved forms in base-rich habitats are straightforward."
  },
  {
    "NAME": "Bryum radiculosum",
    "DIFF": 2,
    "NOTES": "When on base-rich walls. Other habitat forms may need checking."
  },
  {
    "NAME": "Bryum alpinum",
    "DIFF": 2,
    "NOTES": "Distinctive reddish species with a metallic sheen."
  },
  {
    "NAME": "Bryum moravicum",
    "DIFF": 2,
    "NOTES": "Easily recognised when thread-like gemmae are present among leaves."
  },
  {
    "NAME": "Bryum rubens",
    "DIFF": 2,
    "NOTES": "Very common."
  },
  {
    "NAME": "Pohlia elongata",
    "DIFF": 2,
    "NOTES": "Mature capsules essential for certain ID."
  },
  {
    "NAME": "Pohlia drummondii",
    "DIFF": 2,
    "NOTES": "Few large brown bulbils are distinctive."
  },
  {
    "NAME": "Pohlia annotina",
    "DIFF": 2,
    "NOTES": "Common but variable."
  },
  {
    "NAME": "Pohlia melanodon",
    "DIFF": 2,
    "NOTES": "Very common on lowland clay."
  },
  {
    "NAME": "Pohlia wahlenbergii",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Epipterygium tozeri",
    "DIFF": 2,
    "NOTES": "Small but distinctive plant."
  },
  {
    "NAME": "Mnium stellare",
    "DIFF": 2,
    "NOTES": "Only Mnium without a leaf border."
  },
  {
    "NAME": "Cinclidium stygium",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Plagiomnium cuspidatum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Orthotrichum pulchellum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Orthotrichum tenellum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Orthotrichum stramineum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Lewinskya affinis",
    "DIFF": 2,
    "NOTES": "Exceedingly common."
  },
  {
    "NAME": "Ulota bruchii",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Orthodontium lineare",
    "DIFF": 2,
    "NOTES": "Plants with capsules on decaying wood are easily recognised."
  },
  {
    "NAME": "Aulacomnium turgidum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Daltonia splachnoides",
    "DIFF": 2,
    "NOTES": "Plants easily recognised when capsules are present."
  },
  {
    "NAME": "Fontinalis squamosa",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Pseudotaxiphyllum elegans",
    "DIFF": 2,
    "NOTES": "Ubiquitous on lowland acid woodland banks."
  },
  {
    "NAME": "Palustriella falcata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Campylium stellatum",
    "DIFF": 2,
    "NOTES": "Typical plants in wet base-rich habitats are straightforward."
  },
  {
    "NAME": "Leptodictyum riparium",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Warnstorfia fluitans",
    "DIFF": 2,
    "NOTES": "Very variable plant, widespread."
  },
  {
    "NAME": "Sarmentypnum sarmentosum",
    "DIFF": 2,
    "NOTES": "Well-pigmented plants in upland seepages are easy to recognise."
  },
  {
    "NAME": "Straminergon stramineum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Calliergon cordifolium",
    "DIFF": 2,
    "NOTES": "Obvious long costa separates readily from Calliergonella cuspidata in same habitats."
  },
  {
    "NAME": "Calliergon giganteum",
    "DIFF": 2,
    "NOTES": "Bushy habit normally separates this easily from C. cordifolium but care should be taken with stunted plants."
  },
  {
    "NAME": "Sanionia uncinata",
    "DIFF": 2,
    "NOTES": "Pleated leaves and dry habitats are good differentiators from other hook-mosses."
  },
  {
    "NAME": "Hygrohypnella ochracea",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Scorpidium revolvens",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Leskea polycarpa",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Abietinella abietina",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Rhynchostegium riparioides",
    "DIFF": 2,
    "NOTES": "Really common and variable."
  },
  {
    "NAME": "Rhynchostegium murale",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Rhynchostegium confertum",
    "DIFF": 2,
    "NOTES": "Longly beaked capsule lid and smooth seta help separate from Brachthecium spp."
  },
  {
    "NAME": "Rhynchostegiella tenella",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Cirriphyllum crassinervium",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Microeurhynchium pumilum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Oxyrrhynchium hians",
    "DIFF": 2,
    "NOTES": "Ubiquitous plant with few strong distinguishing characters."
  },
  {
    "NAME": "Sciuro-hypnum populeum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Sciuro-hypnum plumosum",
    "DIFF": 2,
    "NOTES": "Very common in fast-flowing rocky rivers and streams."
  },
  {
    "NAME": "Brachythecium rutabulum",
    "DIFF": 2,
    "NOTES": "Very common and variable."
  },
  {
    "NAME": "Brachythecium rivulare",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Scleropodium cespitans",
    "DIFF": 2,
    "NOTES": "Equally at home on damp tarmac and tree bases by silty rivers."
  },
  {
    "NAME": "Homalothecium sericeum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Homalothecium lutescens",
    "DIFF": 2,
    "NOTES": "Mostly in calcareous grassland but also grows on rocks in some districts."
  },
  {
    "NAME": "Hypnum cupressiforme var. cupressiforme",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Hypnum cupressiforme var. lacunosum",
    "DIFF": 2,
    "NOTES": "Base-rich habitat is best differentiator from other robust Hypnum spp."
  },
  {
    "NAME": "Hypnum cupressiforme var. resupinatum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Hypnum andoi",
    "DIFF": 2,
    "NOTES": "Lidded capsules are needed for certain ID."
  },
  {
    "NAME": "Hypnum jutlandicum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Platygyrium repens",
    "DIFF": 2,
    "NOTES": "Increasing."
  },
  {
    "NAME": "Sematophyllum substrumulosum",
    "DIFF": 2,
    "NOTES": "Increasing in conifer plantations."
  },
  {
    "NAME": "Loeskeobryum brevirostre",
    "DIFF": 2,
    "NOTES": "Very distinctive leaves."
  },
  {
    "NAME": "Nogopterium gracile",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Leucodon sciuroides",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Neckera pumila",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Neckera complanata",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Neckera smithii",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Homalia trichomanoides",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Thamnobryum alopecurum",
    "DIFF": 2,
    "NOTES": "Typical woodland forms are straightforward - forms growing by fast-flowing upland watercourses can be very variable."
  },
  {
    "NAME": "Heterocladium heteropterum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Isothecium myosuroides",
    "DIFF": 2,
    "NOTES": "Very common."
  },
  {
    "NAME": "Isothecium alopecuroides",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Hyocomium armoricum",
    "DIFF": 2,
    "NOTES": ""
  },
  {
    "NAME": "Reboulia hemisphaerica",
    "DIFF": 3,
    "NOTES": "Marchantia quadrata and Reboulia hemisphaerica can be a troublesome pair until one is used to them."
  },
  {
    "NAME": "Clevea hyalina",
    "DIFF": 3,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Riccia cavernosa",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Riccia huebeneriana",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Riccia fluitans",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Riccia glauca",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Riccia subbifurca",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Riccia beyrichiana",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Pellia neesiana",
    "DIFF": 3,
    "NOTES": "Best to check sexuality and slime papillae to be sure."
  },
  {
    "NAME": "Fossombronia angulosa",
    "DIFF": 3,
    "NOTES": "Distinctive by its large size and maritime habitat."
  },
  {
    "NAME": "Fossombronia fimbriata",
    "DIFF": 3,
    "NOTES": "Easy, but rare and very small."
  },
  {
    "NAME": "Petalophyllum ralfsii",
    "DIFF": 3,
    "NOTES": "Easy, but rare, except very locally in dune slacks."
  },
  {
    "NAME": "Moerckia hibernica",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Moerckia flotoviana",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Moerckia blyttii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Metzgeria conjugata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Riccardia multifida",
    "DIFF": 3,
    "NOTES": "R. multifida and R. chamedryfolia can be a tricky pair, but oil body characters are useful."
  },
  {
    "NAME": "Riccardia chamedryfolia",
    "DIFF": 3,
    "NOTES": "R. multifida and R. chamedryfolia can be a tricky pair, but oil body characters are useful."
  },
  {
    "NAME": "Riccardia incurvata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Porella platyphylla",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Porella cordaeana",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Porella pinnata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Radula lindenbergiana",
    "DIFF": 3,
    "NOTES": "Really need fertile material to be sure."
  },
  {
    "NAME": "Radula aquilegia",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Frullania microphylla",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Frullania fragilifolia",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Jubula hutchinsiae",
    "DIFF": 3,
    "NOTES": "Easy in the field with more experience, but rather rare oceanic species."
  },
  {
    "NAME": "Cololejeunea microscopica",
    "DIFF": 3,
    "NOTES": "Check microscopically until familiar."
  },
  {
    "NAME": "Myriocoleopsis minutissima",
    "DIFF": 3,
    "NOTES": "Check microscopically until familiar."
  },
  {
    "NAME": "Drepanolejeunea hamatifolia",
    "DIFF": 3,
    "NOTES": "Check microscopically until familiar."
  },
  {
    "NAME": "Harpalejeunea molleri",
    "DIFF": 3,
    "NOTES": "Check microscopically until familiar."
  },
  {
    "NAME": "Lejeunea cavifolia",
    "DIFF": 3,
    "NOTES": "Can be 90% certain in the field with experience."
  },
  {
    "NAME": "Lejeunea lamacerina",
    "DIFF": 3,
    "NOTES": "Can be 90% certain in the field with experience."
  },
  {
    "NAME": "Lejeunea patens",
    "DIFF": 3,
    "NOTES": "Can be 90% certain in the field with experience."
  },
  {
    "NAME": "Lejeunea flava",
    "DIFF": 3,
    "NOTES": "Very rare, Ireland only."
  },
  {
    "NAME": "Marchesinia mackaii",
    "DIFF": 3,
    "NOTES": "Easy in the field with experience."
  },
  {
    "NAME": "Microlejeunea ulicina",
    "DIFF": 3,
    "NOTES": "Check microscopically until familiar."
  },
  {
    "NAME": "Ptilidium pulcherrimum",
    "DIFF": 3,
    "NOTES": "Ptilidium easy to identify, but the species less so; P. pulcherrimum rarer, and an epiphyte."
  },
  {
    "NAME": "Bazzania pearsonii",
    "DIFF": 3,
    "NOTES": "Rarer and more oceanic than B. tricrenata, but can occur together."
  },
  {
    "NAME": "Kurzia pauciflora",
    "DIFF": 3,
    "NOTES": "Thin strands creeping through Sphagnum are usually this species."
  },
  {
    "NAME": "Kurzia trichoclados",
    "DIFF": 3,
    "NOTES": "Usually forms dense fragrant cushions."
  },
  {
    "NAME": "Lepidozia pearsonii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Lophocolea bispinosa",
    "DIFF": 3,
    "NOTES": "Introduction."
  },
  {
    "NAME": "Lophocolea semiteres",
    "DIFF": 3,
    "NOTES": "Spreading introduction."
  },
  {
    "NAME": "Lophocolea fragrans",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Chiloscyphus polyanthos",
    "DIFF": 3,
    "NOTES": "The two species of Chiloscyphus can be difficult to tell apart, and ideally one needs fertile material."
  },
  {
    "NAME": "Chiloscyphus pallescens",
    "DIFF": 3,
    "NOTES": "The two species of Chiloscyphus can be difficult to tell apart, and ideally one needs fertile material."
  },
  {
    "NAME": "Leptoscyphus cuneifolius",
    "DIFF": 3,
    "NOTES": "Small and hyperoceanic, but easy enough in field once one has some experience."
  },
  {
    "NAME": "Plagiochila britannica",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiochila heterophylla",
    "DIFF": 3,
    "NOTES": "Hyperoceanic."
  },
  {
    "NAME": "Plagiochila bifaria",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiochila exigua",
    "DIFF": 3,
    "NOTES": "Like a small blackish P. punctata."
  },
  {
    "NAME": "Pedinophyllum interruptum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Gongylanthus ericetorum",
    "DIFF": 3,
    "NOTES": "Very rare, except in extreme SW, but distinctive."
  },
  {
    "NAME": "Calypogeia azurea",
    "DIFF": 3,
    "NOTES": "The blue oil bodies are diagnostic but don't last long."
  },
  {
    "NAME": "Hygrobiella laxifolia",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Anthelia julacea",
    "DIFF": 3,
    "NOTES": "Anthelia is easy, but the species can be more difficult; however, A. julacea is by far the commonest one."
  },
  {
    "NAME": "Anthelia juratzkana",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Mesoptychia bantriensis",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Mesoptychia fitzgeraldiae",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Mesoptychia collaris",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Mesoptychia heterocolpos",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Mesoptychia badensis",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Mesoptychia turbinata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Eremonotus myriocarpus",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Jungermannia atrovirens",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Jungermannia pumila",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Jungermannia eucordifolia",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Harpanthus flotovianus",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Harpanthus scutatus",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Solenostoma sphaerocarpum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Solenostoma confertissimum",
    "DIFF": 3,
    "NOTES": "Rare."
  },
  {
    "NAME": "Solenostoma gracillimum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Solenostoma hyalinum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Solenostoma paroicum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Solenostoma obovatum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Nardia geoscyphus",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Gymnomitrion adustum",
    "DIFF": 3,
    "NOTES": "Uncommon but distiinctive."
  },
  {
    "NAME": "Gymnomitrion alpinum",
    "DIFF": 3,
    "NOTES": "Mainly snow patch vegetation."
  },
  {
    "NAME": "Marsupella aquatica",
    "DIFF": 3,
    "NOTES": "Not always easy to distincguish from M. emarginata."
  },
  {
    "NAME": "Marsupella stableri",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Syzygiella autumnalis",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Cephalozia catenulata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Cephalozia leucantha",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Cephalozia lunulifolia",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Cephalozia connivens",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Anastrophyllum hellerianum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Anastrophyllum joergensenii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Anastrophyllum alpinum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphenolobus saxicola",
    "DIFF": 3,
    "NOTES": "Rare but quite distinctive."
  },
  {
    "NAME": "Orthocaulis atlanticus",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphenolobopsis pearsonii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Barbilophozia hatcheri",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Barbilophozia lycopodioides",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Barbilophozia sudetica",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Isopaches bicrenatus",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Cephaloziella hampeana",
    "DIFF": 3,
    "NOTES": "The commonest Cephaloziella in  bogs."
  },
  {
    "NAME": "Cephaloziella divaricata",
    "DIFF": 3,
    "NOTES": "The commonest Cephaloziella."
  },
  {
    "NAME": "Cephaloziella turneri",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Obtusifolium obtusum",
    "DIFF": 3,
    "NOTES": "Rather rare but distinctive."
  },
  {
    "NAME": "Lophozia longidens",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Lophozia excisa",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Diplophyllum taxifolium",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Diplophyllum obtusifolium",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scapania compacta",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scapania cuspiduligera",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scapania scandica",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scapania irrigua",
    "DIFF": 3,
    "NOTES": "Common but often overlooked."
  },
  {
    "NAME": "Scapania subalpina",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scapania uliginosa",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scapania paludosa",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scapania aequiloba",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scapania aspera",
    "DIFF": 3,
    "NOTES": "Can usually be determined in the field with experience."
  },
  {
    "NAME": "Sphagnum strictum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum compactum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum austinii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum papillosum",
    "DIFF": 3,
    "NOTES": "Hummock-forming plants on significant peat usually straightforward."
  },
  {
    "NAME": "Sphagnum medium",
    "DIFF": 3,
    "NOTES": "Widespread bog species."
  },
  {
    "NAME": "Sphagnum divinum",
    "DIFF": 3,
    "NOTES": "Uncommon in north and Ireland."
  },
  {
    "NAME": "Sphagnum teres",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum russowii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum quinquefarium",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum subnitens",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum molle",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum subsecundum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum inundatum",
    "DIFF": 3,
    "NOTES": "Can be confused with S. auriculatum."
  },
  {
    "NAME": "Sphagnum auriculatum",
    "DIFF": 3,
    "NOTES": "Often confused with S. inundatum but is more common in many areas."
  },
  {
    "NAME": "Sphagnum contortum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum pulchrum",
    "DIFF": 3,
    "NOTES": "Usually a robust plant but care needed to differentiate more slender forms from S. fallax forma isoviitae."
  },
  {
    "NAME": "Sphagnum fallax",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum flexuosum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum angustifolium",
    "DIFF": 3,
    "NOTES": "Seems nearly absent from southern districts."
  },
  {
    "NAME": "Andreaea hookeri",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Oedipodium griffithianum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Atrichum crispum",
    "DIFF": 3,
    "NOTES": "Increasing by upland watercourses."
  },
  {
    "NAME": "Atrichum tenellum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Polytrichastrum sexangulare",
    "DIFF": 3,
    "NOTES": "Characteristic snowbed plant."
  },
  {
    "NAME": "Pogonatum nanum",
    "DIFF": 3,
    "NOTES": "Scarce plant - mature capsules essential for certain ID."
  },
  {
    "NAME": "Polytrichum longisetum",
    "DIFF": 3,
    "NOTES": "Immature plants of P. formosum can be mistaken for P. longisteum."
  },
  {
    "NAME": "Encalypta alpina",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Encalypta pilifera",
    "DIFF": 3,
    "NOTES": "Rare - only known from Carboniferous Limestone in N, England and N. Wales."
  },
  {
    "NAME": "Entosthodon muhlenbergii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Entosthodon pulchellus",
    "DIFF": 3,
    "NOTES": "Rare plant - mature capsules needed for certain ID."
  },
  {
    "NAME": "Entosthodon obtusus",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Physcomitrium sphaericum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Catoscopium nigritum",
    "DIFF": 3,
    "NOTES": "Rare but easy to recognise when mature capsules are present."
  },
  {
    "NAME": "Distichium inclinatum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Archidium alternifolium",
    "DIFF": 3,
    "NOTES": "Rarely found with capsules - stringy-looking gametophytes are common on trampled acid soil."
  },
  {
    "NAME": "Dicranodontium denudatum",
    "DIFF": 3,
    "NOTES": "Broken-off shoot tips often give this plant away."
  },
  {
    "NAME": "Campylopus fragilis",
    "DIFF": 3,
    "NOTES": "Cushions often have a distinctive 'starburst' appearance caused by numerous broken shoots within."
  },
  {
    "NAME": "Campylopus pyriformis",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Campylopus flexuosus",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Leucobryum juniperoideum",
    "DIFF": 3,
    "NOTES": "Mostly found in oak and beech woodland but there is some overlap with L. glaucum in such habitats."
  },
  {
    "NAME": "Dichodontium pellucidum",
    "DIFF": 3,
    "NOTES": "Longer-leaved forms should be checked to eliminate D. flavescens."
  },
  {
    "NAME": "Dichodontium flavescens",
    "DIFF": 3,
    "NOTES": "Capsules needed for ID."
  },
  {
    "NAME": "Aongstroemia longipes",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Dicranella schreberiana",
    "DIFF": 3,
    "NOTES": "Some plants may resemble Trichodon cylindricus."
  },
  {
    "NAME": "Dicranella staphylina",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens pusillus",
    "DIFF": 3,
    "NOTES": "Tends to grow in damper habitats than F. gracilifolius."
  },
  {
    "NAME": "Fissidens gracilifolius",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens bryoides var. caespitans",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens rivularis",
    "DIFF": 3,
    "NOTES": "Border is very strong and may even appear orange-to red coloured in older leaves."
  },
  {
    "NAME": "Fissidens crassipes",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens exilis",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens dubius",
    "DIFF": 3,
    "NOTES": "Care should be taken not to confuse with F. adianthoides as there is some crossover of habitats."
  },
  {
    "NAME": "Fissidens adianthoides",
    "DIFF": 3,
    "NOTES": "Care should be taken not to confuse with F. dubius as there is some crossover of habitats."
  },
  {
    "NAME": "Dicranum polysetum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Dicranum spurium",
    "DIFF": 3,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Dicranum fuscescens",
    "DIFF": 3,
    "NOTES": "Resembles many other narrow-leaved upland cushion-formers when non-fertile."
  },
  {
    "NAME": "Dicranum montanum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Rhabdoweisia crenulata",
    "DIFF": 3,
    "NOTES": "Most humidity-demanding species."
  },
  {
    "NAME": "Cynodontium bruntonii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Glyphomitrium daviesii",
    "DIFF": 3,
    "NOTES": "Very distinctive capsules."
  },
  {
    "NAME": "Pleuridium acuminatum",
    "DIFF": 3,
    "NOTES": "Male structures are often difficult to see in the field so do not assume all material is by default P. acuminatum."
  },
  {
    "NAME": "Pleuridium subulatum",
    "DIFF": 3,
    "NOTES": "Less common than P. acuminatum and often on less acid soils."
  },
  {
    "NAME": "Ditrichum heteromallum",
    "DIFF": 3,
    "NOTES": "Common plant in uplands."
  },
  {
    "NAME": "Cheilothela chloropus",
    "DIFF": 3,
    "NOTES": "Rare species of costal limestone. Can resemble Polytrichum spp. and/or Pseudocrossidium hornschchianum."
  },
  {
    "NAME": "Eucladium verticillatum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Weissia controversa var. crispata",
    "DIFF": 3,
    "NOTES": "Plants are often distinctly red-tinged. Likes calcareous soils."
  },
  {
    "NAME": "Weissia controversa var. densifolia",
    "DIFF": 3,
    "NOTES": "Forms deep turfs and likes metalliferous waste."
  },
  {
    "NAME": "Weissia perssonii",
    "DIFF": 3,
    "NOTES": "Nearly confined to the coast."
  },
  {
    "NAME": "Weissia rutilans",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Weissia brachycarpa var. brachycarpa",
    "DIFF": 3,
    "NOTES": "Mature capsules essential for certain ID. Likes acid soils."
  },
  {
    "NAME": "Weissia brachycarpa var. obliqua",
    "DIFF": 3,
    "NOTES": "Mature capsules essential for certain ID. Likes basic soils."
  },
  {
    "NAME": "Weissia squarrosa",
    "DIFF": 3,
    "NOTES": "Rare species."
  },
  {
    "NAME": "Weissia rostellata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Weissia sterilis",
    "DIFF": 3,
    "NOTES": "Capsules needed for ID."
  },
  {
    "NAME": "Weissia levieri",
    "DIFF": 3,
    "NOTES": "Very rare plant - mature capsules essential for certain ID."
  },
  {
    "NAME": "Weissia longifolia",
    "DIFF": 3,
    "NOTES": "Capsules needed for ID."
  },
  {
    "NAME": "Weissia angustifolia",
    "DIFF": 3,
    "NOTES": "Capsules needed for ID."
  },
  {
    "NAME": "Trichostomum brachydontium",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Tortella inflexa",
    "DIFF": 3,
    "NOTES": "Looks like a Weissia growing on rock, Confined to chalk and oolite in S. England."
  },
  {
    "NAME": "Tortella flavovirens",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Tortella densa",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Hymenostylium recurvirostrum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Gyroweisia tenuis",
    "DIFF": 3,
    "NOTES": "Capsules are occasional in the N and W but very rarely found elsewhere."
  },
  {
    "NAME": "Gymnostomum calcareum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Molendoa warburgii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Ephemerum recurvifolium",
    "DIFF": 3,
    "NOTES": "The commonest species in dry calcareous places."
  },
  {
    "NAME": "Ephemerum stoloniferum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Ephemerum serratum",
    "DIFF": 3,
    "NOTES": "The commonest species of dry acid places."
  },
  {
    "NAME": "Dialytrichia saxicola",
    "DIFF": 3,
    "NOTES": "D. mucronata can also be very fragile-leaved."
  },
  {
    "NAME": "Bryoerythrophyllum ferruginascens",
    "DIFF": 3,
    "NOTES": "Regarded as an upland plant, it is spreading into lowland calcareous habitats."
  },
  {
    "NAME": "Bryoerythrophyllum caledonicum",
    "DIFF": 3,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Leptodontium flexifolium",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Didymodon ferrugineus",
    "DIFF": 3,
    "NOTES": "Plants in S. and E. England."
  },
  {
    "NAME": "Didymodon spadiceus",
    "DIFF": 3,
    "NOTES": "Often by water, mostly an upland plant."
  },
  {
    "NAME": "Didymodon vinealis",
    "DIFF": 3,
    "NOTES": "Inconsistently recorded and often confused with D. insulanus."
  },
  {
    "NAME": "Didymodon rigidulus",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Stegonia latifolia",
    "DIFF": 3,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Pterygoneurum ovatum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Aloina ambigua",
    "DIFF": 3,
    "NOTES": "Mature capsules essential for certain identification."
  },
  {
    "NAME": "Tortula schimperi",
    "DIFF": 3,
    "NOTES": "Mostly a species of East Anglia."
  },
  {
    "NAME": "Tortula freibergii",
    "DIFF": 3,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Tortula marginata",
    "DIFF": 3,
    "NOTES": "Do not confuse with T. muralis var. aestiva."
  },
  {
    "NAME": "Tortula atrovirens",
    "DIFF": 3,
    "NOTES": "Restricted to maritime habitats."
  },
  {
    "NAME": "Tortula lindbergii",
    "DIFF": 3,
    "NOTES": "Mature capsules essential for certain ID."
  },
  {
    "NAME": "Tortula caucasica",
    "DIFF": 3,
    "NOTES": "Should only be identified when capsules are fully grown."
  },
  {
    "NAME": "Tortula protobryoides",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Microbryum starckeanum",
    "DIFF": 3,
    "NOTES": "Scarce primarily coastal species."
  },
  {
    "NAME": "Microbryum davallianum",
    "DIFF": 3,
    "NOTES": "Common winter annual."
  },
  {
    "NAME": "Microbryum floerkeanum",
    "DIFF": 3,
    "NOTES": "Like Tortula acaulon but smaller and browner. August to December."
  },
  {
    "NAME": "Acaulon muticum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Acaulon mediterraneum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Acaulon triquetrum",
    "DIFF": 3,
    "NOTES": "Very rare and minute plant of the south coast."
  },
  {
    "NAME": "Syntrichia virescens",
    "DIFF": 3,
    "NOTES": "Small plants often with emarginate leaf apices, often in 'grotty' places."
  },
  {
    "NAME": "Seligeria pusilla",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Seligeria acutifolia",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Seligeria calycina",
    "DIFF": 3,
    "NOTES": "Quite common on chalk."
  },
  {
    "NAME": "Seligeria calcarea",
    "DIFF": 3,
    "NOTES": "Quite common on chalk."
  },
  {
    "NAME": "Seligeria trifaria",
    "DIFF": 3,
    "NOTES": "Very rare, only distinguishable from S. patula when mature capsules present."
  },
  {
    "NAME": "Seligeria patula",
    "DIFF": 3,
    "NOTES": "Only distinguishable from S. trifaria when mature capsules present."
  },
  {
    "NAME": "Campylostelium saxicola",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Brachydontium trichodes",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium platyphyllum",
    "DIFF": 3,
    "NOTES": "Especially characteristic of upland streams on base-rich rock."
  },
  {
    "NAME": "Schistidium apocarpum",
    "DIFF": 3,
    "NOTES": "Plants typically have curved leaves, reddish stems and very short hairpoints. In wetter districts."
  },
  {
    "NAME": "Schistidium strictum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium elegantulum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia longirostris",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia orbicularis",
    "DIFF": 3,
    "NOTES": "Like G. pulvinata but much scarcer."
  },
  {
    "NAME": "Grimmia torquata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia funalis",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia lisae",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia dissimulata",
    "DIFF": 3,
    "NOTES": "Lowland species of sheltered basic substrate."
  },
  {
    "NAME": "Grimmia decipiens",
    "DIFF": 3,
    "NOTES": "Like a large G. pulvinata but grows on more acid rock. Capsules usually present."
  },
  {
    "NAME": "Grimmia ramondii",
    "DIFF": 3,
    "NOTES": "Large species of mainly riparian habitats in uplands. Recognised by winged back of nerve."
  },
  {
    "NAME": "Racomitrium ellipticum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Racomitrium sudeticum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Racomitrium obtusum",
    "DIFF": 3,
    "NOTES": "Separation from R. heterostichum may be difficult."
  },
  {
    "NAME": "Racomitrium heterostichum",
    "DIFF": 3,
    "NOTES": "Separation from R. affine may be difficult."
  },
  {
    "NAME": "Racomitrium ericoides",
    "DIFF": 3,
    "NOTES": "Can be difficult to separate from R. elongatum."
  },
  {
    "NAME": "Racomitrium elongatum",
    "DIFF": 3,
    "NOTES": "Can be difficult to separate from R. ericoides."
  },
  {
    "NAME": "Racomitrium canescens",
    "DIFF": 3,
    "NOTES": "Scarce plant of basic rocks."
  },
  {
    "NAME": "Hedwigia ciliata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Braunia imberbis",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Tayloria lingulata",
    "DIFF": 3,
    "NOTES": "A rare but distinctive species."
  },
  {
    "NAME": "Splachnum vasculosum",
    "DIFF": 3,
    "NOTES": "Commonest species in lowlands."
  },
  {
    "NAME": "Meesia uliginosa",
    "DIFF": 3,
    "NOTES": "Is distinctive when mature capsules are present."
  },
  {
    "NAME": "Amblyodon dealbatus",
    "DIFF": 3,
    "NOTES": "Is distinctive when mature capsules are present."
  },
  {
    "NAME": "Conostomum tetragonum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Philonotis rigida",
    "DIFF": 3,
    "NOTES": "Rare but distinctive."
  },
  {
    "NAME": "Philonotis capillaris",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Philonotis cernua",
    "DIFF": 3,
    "NOTES": "Very rare - capsules needed for identification."
  },
  {
    "NAME": "Bryum julaceum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Bryum concinnatum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Bryum canariense",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Bryum ruderale",
    "DIFF": 3,
    "NOTES": "Rhizoidal tubers and rhizoids are characteristic."
  },
  {
    "NAME": "Bryum violaceum",
    "DIFF": 3,
    "NOTES": "Rhizoidal tubers and rhizoids are characteristic."
  },
  {
    "NAME": "Bryum klinggraeffii",
    "DIFF": 3,
    "NOTES": "Rhizoidal tubers and rhizoids are characteristic."
  },
  {
    "NAME": "Bryum sauteri",
    "DIFF": 3,
    "NOTES": "Rhizoidal tubers and rhizoids are characteristic."
  },
  {
    "NAME": "Bryum riparium",
    "DIFF": 3,
    "NOTES": "Rhizoidal tubers and rhizoids are characteristic."
  },
  {
    "NAME": "Bryum subapiculatum",
    "DIFF": 3,
    "NOTES": "Rhizoidal tubers and rhizoids are characteristic."
  },
  {
    "NAME": "Bryum zieri",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Bryum pallens",
    "DIFF": 3,
    "NOTES": "Relative common, red-tinged species."
  },
  {
    "NAME": "Bryum weigelii",
    "DIFF": 3,
    "NOTES": "Large, distinctive pinkish species of flushes and other wet habitats."
  },
  {
    "NAME": "Bryum donianum",
    "DIFF": 3,
    "NOTES": "Locally common on banks or in wall crevices."
  },
  {
    "NAME": "Bryum elegans",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Bryum torquescens",
    "DIFF": 3,
    "NOTES": "Not reliably recognisable without capsules."
  },
  {
    "NAME": "Bryum pallescens",
    "DIFF": 3,
    "NOTES": "Deep, blackish cushions in metallifeous drip zones are characteristic."
  },
  {
    "NAME": "Bryum caespiticium",
    "DIFF": 3,
    "NOTES": "Much over-recorded; mature capsules essential for certain ID."
  },
  {
    "NAME": "Bryum kunzei",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Mielichhoferia elongata",
    "DIFF": 3,
    "NOTES": "Rare species of very acid, metal-rich rocks."
  },
  {
    "NAME": "Pohlia cruda",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Pohlia nutans",
    "DIFF": 3,
    "NOTES": "Common but very variable."
  },
  {
    "NAME": "Pohlia filum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Pohlia camptotrachela",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Pohlia flexuosa",
    "DIFF": 3,
    "NOTES": "Has very distinctive orange angular bulbils."
  },
  {
    "NAME": "Pohlia ludwigii",
    "DIFF": 3,
    "NOTES": "Characteristic snowbed plant."
  },
  {
    "NAME": "Pohlia lutescens",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Pohlia lescuriana",
    "DIFF": 3,
    "NOTES": "Quite rare; rhizoidal tubers needed for certain ID."
  },
  {
    "NAME": "Rhizomnium magnifolium",
    "DIFF": 3,
    "NOTES": "Rare Scottish plant."
  },
  {
    "NAME": "Rhizomnium pseudopunctatum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiomnium affine",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiomnium elatum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiomnium rostratum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Pseudobryum cinclidioides",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Zygodon viridissimus",
    "DIFF": 3,
    "NOTES": "Commonest Zygodon in dry places; grows on bark and rock."
  },
  {
    "NAME": "Zygodon stirtonii",
    "DIFF": 3,
    "NOTES": "On rock - costa excurrent and widened above."
  },
  {
    "NAME": "Zygodon rupestris",
    "DIFF": 3,
    "NOTES": "Frequent in ancient woodland."
  },
  {
    "NAME": "Zygodon conoideus",
    "DIFF": 3,
    "NOTES": "Most common in humid districts."
  },
  {
    "NAME": "Codonoblepharon forsteri",
    "DIFF": 3,
    "NOTES": "Very rare plant of ancient wood-pasture."
  },
  {
    "NAME": "Orthotrichum cupulatum",
    "DIFF": 3,
    "NOTES": "Mature capsules essential for certain ID."
  },
  {
    "NAME": "Orthotrichum rivulare",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Orthotrichum sprucei",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Lewinskya rupestris",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Lewinskya speciosa",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Ulota coarctata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Ulota hutchinsiae",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Ulota drummondii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Ulota crispula",
    "DIFF": 3,
    "NOTES": "Mature capsules essential for certain ID."
  },
  {
    "NAME": "Ulota intermedia",
    "DIFF": 3,
    "NOTES": "Mature capsules essential for certain ID."
  },
  {
    "NAME": "Ulota crispa",
    "DIFF": 3,
    "NOTES": "Mature capsules essential for certain ID."
  },
  {
    "NAME": "Ulota calvescens",
    "DIFF": 3,
    "NOTES": "Spreading east from west."
  },
  {
    "NAME": "Calyptrochaeta apiculata",
    "DIFF": 3,
    "NOTES": "Quite distinctive but very rare."
  },
  {
    "NAME": "Cyclodictyon laetevirens",
    "DIFF": 3,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Myurella julacea",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Myurella tenerrima",
    "DIFF": 3,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Orthothecium intricatum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiothecium denticulatum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiothecium laetum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiothecium curvifolium",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiothecium cavifolium",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiothecium succulentum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Plagiothecium nemorale",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Herzogiella seligeri",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Pterigynandrum filiforme",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Myrinia pulvinata",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Kandaea elodes",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Palustriella decipiens",
    "DIFF": 3,
    "NOTES": "Rare Scottish plant."
  },
  {
    "NAME": "Campylium protensum",
    "DIFF": 3,
    "NOTES": "Easy to confuse in the field with C. chrysophyllum."
  },
  {
    "NAME": "Campylium chrysophyllum",
    "DIFF": 3,
    "NOTES": "Easy to confuse in the field with C. protensum."
  },
  {
    "NAME": "Hygroamblystegium fluviatile",
    "DIFF": 3,
    "NOTES": "Robust western forms are straightforward - tends to morph into H. tenax on the edges of its range."
  },
  {
    "NAME": "Hygroamblystegium tenax",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Hygroamblystegium varium",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Hygroamblystegium humile",
    "DIFF": 3,
    "NOTES": "Straggly-looking plant, probably overlooked."
  },
  {
    "NAME": "Drepanocladus aduncus",
    "DIFF": 3,
    "NOTES": "Common but extremely variable plant."
  },
  {
    "NAME": "Drepanocladus lycopodioides",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Drepanocladus trifarius",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Tomentypnum nitens",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Hygrohypnum luridum",
    "DIFF": 3,
    "NOTES": "Very variable. Small forms grow on basic rock away from water in humid places."
  },
  {
    "NAME": "Campylophyllopsis calcarea",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Campylophyllum halleri",
    "DIFF": 3,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Sarmentypnum exannulatum",
    "DIFF": 3,
    "NOTES": "Easily confused with other hook mosses of wet places."
  },
  {
    "NAME": "Sanionia orthothecioides",
    "DIFF": 3,
    "NOTES": "Rare plant of coastal N. Scotland."
  },
  {
    "NAME": "Hamatocaulis vernicosus",
    "DIFF": 3,
    "NOTES": "Pleated leaves and red spots at leaf bases good indicators for this protected species."
  },
  {
    "NAME": "Scorpidium cossonii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Lescuraea patens",
    "DIFF": 3,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Lescuraea plicata",
    "DIFF": 3,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Thuidium delicatulum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Thuidium assimile",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scorpiurium circinatum",
    "DIFF": 3,
    "NOTES": "Moist and dry appearances are very different."
  },
  {
    "NAME": "Plasteurhynchium striatulum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Rhynchostegium alopecuroides",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Rhynchostegium megapolitanum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Rhynchostegiella litorea",
    "DIFF": 3,
    "NOTES": "Capsules are needed fo certain ID."
  },
  {
    "NAME": "Rhynchostegiella teneriffae",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Oxyrrhynchium schleicheri",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Oxyrrhynchium speciosum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Brachythecium glareosum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Brachythecium salebrosum",
    "DIFF": 3,
    "NOTES": "Smooth seta helps distinguish from similar Brachythecium spp."
  },
  {
    "NAME": "Brachythecium mildeanum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Scleropodium touretii",
    "DIFF": 3,
    "NOTES": "Usually coastal."
  },
  {
    "NAME": "Brachytheciastrum velutinum",
    "DIFF": 3,
    "NOTES": "Much scarcer in many areas than some books suggest. Need capsules to separate from Rhynchostegium confertum."
  },
  {
    "NAME": "Hypnum imponens",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Taxiphyllum wissgrillii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Pseudohygrohypnum eugyrium",
    "DIFF": 3,
    "NOTES": "Similar to P. subeugyrium - needs microscope checking."
  },
  {
    "NAME": "Calliergonella lindbergii",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Pylaisia polyantha",
    "DIFF": 3,
    "NOTES": "Increasing. Young sporophytes nearly always present with older ones."
  },
  {
    "NAME": "Sematophyllum demissum",
    "DIFF": 3,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Rhytidiadelphus subpinnatus",
    "DIFF": 3,
    "NOTES": "Rather rare."
  },
  {
    "NAME": "Hylocomiastrum pyrenaicum",
    "DIFF": 3,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Hylocomiastrum umbratum",
    "DIFF": 3,
    "NOTES": "Only in the most humid and sheltered places."
  },
  {
    "NAME": "Hageniella micans",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Entodon concinnus",
    "DIFF": 3,
    "NOTES": "May be confused with both Pseudoscleropodium purum and Calliergonlla cuspidata."
  },
  {
    "NAME": "Dendrocryphaea lamyana",
    "DIFF": 3,
    "NOTES": "Rare plant confined to inundation zone of a few rivers."
  },
  {
    "NAME": "Antitrichia curtipendula",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Heterocladium flaccidum",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Heterocladium wulfsbergii",
    "DIFF": 3,
    "NOTES": "Usually a plant of rocks by waterfalls and cascades."
  },
  {
    "NAME": "Isothecium interludens",
    "DIFF": 3,
    "NOTES": ""
  },
  {
    "NAME": "Isothecium holtii",
    "DIFF": 3,
    "NOTES": "Very habitat restricted to fast flowing rivers but may be confused with Thamnobryum alopecurum from the same places."
  },
  {
    "NAME": "Anthoceros punctatus",
    "DIFF": 4,
    "NOTES": "Easy to recognise Anthoceros, less easy to distinguish the species."
  },
  {
    "NAME": "Anthoceros agrestis",
    "DIFF": 4,
    "NOTES": "Easy to recognise Anthoceros, less easy to distinguish the species."
  },
  {
    "NAME": "Phaeoceros laevis",
    "DIFF": 4,
    "NOTES": "Easy to recognise Phaeoceros, less easy to distinguish the species."
  },
  {
    "NAME": "Phaeoceros carolinianus",
    "DIFF": 4,
    "NOTES": "Easy to recognise Phaeoceros, less easy to distinguish the species."
  },
  {
    "NAME": "Sphaerocarpos michelii",
    "DIFF": 4,
    "NOTES": "Easy to recognise Sphaerocarpos less easy to distinguish the species."
  },
  {
    "NAME": "Sphaerocarpos europaeus",
    "DIFF": 4,
    "NOTES": "Easy to recognise Sphaerocarpos less easy to distinguish the species."
  },
  {
    "NAME": "Riccia crystallina",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Riccia rhenana",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Riccia canaliculata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fossombronia foveolata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fossombronia caespitiformis",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fossombronia husnotii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fossombronia pusilla",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fossombronia maritima",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fossombronia wondraczekii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fossombronia incurva",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Radula voluta",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cololejeunea calcarea",
    "DIFF": 4,
    "NOTES": "Although C. rossettiana can more or less be discounted in northern areas."
  },
  {
    "NAME": "Cololejeunea rossettiana",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Kurzia sylvatica",
    "DIFF": 4,
    "NOTES": "Not fragrant."
  },
  {
    "NAME": "Telaranea europaea",
    "DIFF": 4,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Calypogeia neesiana",
    "DIFF": 4,
    "NOTES": "Important to check Calypogeia oil bodies as soon as possible after collecting, as they don't last."
  },
  {
    "NAME": "Calypogeia integristipula",
    "DIFF": 4,
    "NOTES": "Important to check Calypogeia oil bodies as soon as possible after collecting, as they don't last."
  },
  {
    "NAME": "Calypogeia sphagnicola",
    "DIFF": 4,
    "NOTES": "Important to check Calypogeia oil bodies as soon as possible after collecting, as they don't last."
  },
  {
    "NAME": "Calypogeia suecica",
    "DIFF": 4,
    "NOTES": "Important to check Calypogeia oil bodies as soon as possible after collecting, as they don't last."
  },
  {
    "NAME": "Jungermannia borealis",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Endogemma caespiticia",
    "DIFF": 4,
    "NOTES": "Rare."
  },
  {
    "NAME": "Solenostoma subellipticum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Nardia breidleri",
    "DIFF": 4,
    "NOTES": "Snow patch vegetation only."
  },
  {
    "NAME": "Gymnomitrion corallioides",
    "DIFF": 4,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Gymnomitrion brevissimum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Marsupella sphacelata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Marsupella funckii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Marsupella sprucei",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Marsupella condensata",
    "DIFF": 4,
    "NOTES": "Snow patch vegetation only."
  },
  {
    "NAME": "Cephalozia macrostachya",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cephalozia pleniceps",
    "DIFF": 4,
    "NOTES": "Can be 90% certain in the field with experience."
  },
  {
    "NAME": "Cephalozia loitlesbergeri",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cephalozia crassifolia",
    "DIFF": 4,
    "NOTES": "Ireland only."
  },
  {
    "NAME": "Cephalozia albescens",
    "DIFF": 4,
    "NOTES": "Mainly snow patch vegetation."
  },
  {
    "NAME": "Odontoschisma fluitans",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Odontoschisma francisci",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Odontoschisma elongatum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Odontoschisma macounii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Barbilophozia quadriloba",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Barbilophozia kunzeana",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cephaloziella rubella",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cephaloziella baumgartneri",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cephaloziella stellulifera",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cephaloziella integerrima",
    "DIFF": 4,
    "NOTES": "Rare."
  },
  {
    "NAME": "Oleolophozia perssonii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Heterogemma capitata",
    "DIFF": 4,
    "NOTES": "Rare."
  },
  {
    "NAME": "Tritomaria exsectiformis",
    "DIFF": 4,
    "NOTES": "Need to check gemmae."
  },
  {
    "NAME": "Tritomaria exsecta",
    "DIFF": 4,
    "NOTES": "Need to check gemmae."
  },
  {
    "NAME": "Schistochilopsis opacifolia",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Saccobasis polita",
    "DIFF": 4,
    "NOTES": "Rare."
  },
  {
    "NAME": "Scapania gymnostomophila",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Scapania calcicola",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Scapania curta",
    "DIFF": 4,
    "NOTES": "Probably under-recorded."
  },
  {
    "NAME": "Scapania lingulata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Scapania degenii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Scapania paludicola",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum affine",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum warnstorfii",
    "DIFF": 4,
    "NOTES": "May strongly resemble S. rubellum in the field but restricted to very base-rich water."
  },
  {
    "NAME": "Sphagnum fuscum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum beothuk",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum skyense",
    "DIFF": 4,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Sphagnum platyphyllum",
    "DIFF": 4,
    "NOTES": "Rare species restricted mainly to very base-rich flushes."
  },
  {
    "NAME": "Sphagnum majus",
    "DIFF": 4,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Sphagnum riparium",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Sphagnum lindbergii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Andreaea alpestris",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Andreaea mutabilis",
    "DIFF": 4,
    "NOTES": "Small flattened cushions with many tiny crimson perigonia are distinctive."
  },
  {
    "NAME": "Andreaea sinuosa",
    "DIFF": 4,
    "NOTES": "Very rare plant of places where snow lies late."
  },
  {
    "NAME": "Andreaea rothii subsp. rothii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Andreaea rothii subsp. falcata",
    "DIFF": 4,
    "NOTES": "Many recorders incorrectly assume all A. rothii is subsp. falcata."
  },
  {
    "NAME": "Andreaea frigida",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Andreaea megistospora",
    "DIFF": 4,
    "NOTES": "Large but very rare plant."
  },
  {
    "NAME": "Andreaea blyttii",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Andreaea nivalis",
    "DIFF": 4,
    "NOTES": "Locally common in the Scottish Highlands."
  },
  {
    "NAME": "Tetrodontium repandum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Atrichum flavisetum",
    "DIFF": 4,
    "NOTES": "Possibly extinct."
  },
  {
    "NAME": "Atrichum angustatum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Polytrichastrum alpinum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Polytrichum perigoniale",
    "DIFF": 4,
    "NOTES": "Occurs in habitats that are seasonally dry. Likely under-recorded."
  },
  {
    "NAME": "Timmia austriaca",
    "DIFF": 4,
    "NOTES": "Very rare, resembling a Polytrichum."
  },
  {
    "NAME": "Timmia norvegica",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Timmia megapolitana",
    "DIFF": 4,
    "NOTES": "Very rare, resembling an Atrichum."
  },
  {
    "NAME": "Encalypta rhaptocarpa",
    "DIFF": 4,
    "NOTES": "Rare plant, mature capsules needed for identification."
  },
  {
    "NAME": "Encalypta brevicolla",
    "DIFF": 4,
    "NOTES": "Very rare - mature capsules needed for identification."
  },
  {
    "NAME": "Entosthodon fascicularis",
    "DIFF": 4,
    "NOTES": "Only Entosthodon that grows on base-rich substrates."
  },
  {
    "NAME": "Entosthodon mouretii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Physcomitrium eurystomum",
    "DIFF": 4,
    "NOTES": "Rare Breckland specialist."
  },
  {
    "NAME": "Physcomitrium readeri",
    "DIFF": 4,
    "NOTES": "Very rare colonist of bare mud on reservoir margins."
  },
  {
    "NAME": "Flexitrichum flexicaule",
    "DIFF": 4,
    "NOTES": "Much scarcer than F. gracile and usually much smaller."
  },
  {
    "NAME": "Hymenoloma crispulum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Micromitrium tenerum",
    "DIFF": 4,
    "NOTES": "Minute plant, very similar-looking to Ephemerum spp."
  },
  {
    "NAME": "Dicranodontium uncinatum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Dicranodontium asperulum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Dicranodontium subporodictyon",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Campylopus subulatus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Campylopus schimperi",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Campylopus gracilis",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Campylopus setifolius",
    "DIFF": 4,
    "NOTES": "Robust montane species."
  },
  {
    "NAME": "Campylopus shawii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Campylopus pilifer",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Campylopus brevipilus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Amphidium lapponicum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Dicranella grevilleana",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Dicranella crispa",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Dicranella subulata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Dicranella howei",
    "DIFF": 4,
    "NOTES": "Perhaps common on chalk and limestone in southern Britain. Leaf sectioning essential."
  },
  {
    "NAME": "Fissidens viridulus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens crispus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens monguillonii",
    "DIFF": 4,
    "NOTES": "Rare plant - can only be identified with certainty when perichaetial leaves and capsules are present."
  },
  {
    "NAME": "Fissidens rufulus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens curvatus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Fissidens serrulatus",
    "DIFF": 4,
    "NOTES": "Very rare plant - resembles F. adianthoides but has mammillose leaf cells."
  },
  {
    "NAME": "Dicranum leioneuron",
    "DIFF": 4,
    "NOTES": "Rare plant, easy to confuse with forms of D. scoparium or D. bonjeanii."
  },
  {
    "NAME": "Dicranum spadiceum",
    "DIFF": 4,
    "NOTES": "Very rare Scottish plant; only recently discovered."
  },
  {
    "NAME": "Dicranum undulatum",
    "DIFF": 4,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Dicranum flexicaule",
    "DIFF": 4,
    "NOTES": "Rare and can be mistaken for D. fuscescens in the field."
  },
  {
    "NAME": "Dicranum elongatum",
    "DIFF": 4,
    "NOTES": "Very rare and possibly extinct."
  },
  {
    "NAME": "Dicranum scottianum",
    "DIFF": 4,
    "NOTES": "May be confused with D. fuscescens esp. without capsules."
  },
  {
    "NAME": "Dicranum flagellare",
    "DIFF": 4,
    "NOTES": "Could be confused with the very common Campylopus flexuosus in the field."
  },
  {
    "NAME": "Paraleucobryum longifolium",
    "DIFF": 4,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Rhabdoweisia fugax",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Rhabdoweisia crispata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cynodontium strumiferum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cynodontium jenneri",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cynodontium polycarpon",
    "DIFF": 4,
    "NOTES": "Rare plant mature capsules needed."
  },
  {
    "NAME": "Cynodontium fallax",
    "DIFF": 4,
    "NOTES": "Possibly extinct."
  },
  {
    "NAME": "Cynodontium tenellum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Oncophorus virens",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Oncophorus wahlenbergii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Oncophorus integerrimus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Arctoa anderssonii",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Kiaeria falcata",
    "DIFF": 4,
    "NOTES": "Scottish snowbed specialist."
  },
  {
    "NAME": "Kiaeria blyttii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Kiaeria starkei",
    "DIFF": 4,
    "NOTES": "Scottish Snowbed specialist."
  },
  {
    "NAME": "Kiaeria glacialis",
    "DIFF": 4,
    "NOTES": "Scottish snowbed specialist."
  },
  {
    "NAME": "Ditrichum pusillum",
    "DIFF": 4,
    "NOTES": "Rare and diminutive plant."
  },
  {
    "NAME": "Ditrichum cornubicum",
    "DIFF": 4,
    "NOTES": "Very rare and diminutive plant of copper mine waste."
  },
  {
    "NAME": "Ditrichum lineare",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Ditrichum plumbicola",
    "DIFF": 4,
    "NOTES": "Lead-mine specialist. Tiny plant."
  },
  {
    "NAME": "Ditrichum zonatum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Ditrichum pallidum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Ditrichum subulatum",
    "DIFF": 4,
    "NOTES": "Rare plant of mainly coastal habitats in SW England and SW Wales."
  },
  {
    "NAME": "Scopelophila cataractae",
    "DIFF": 4,
    "NOTES": "Rare moss of copper mine waste."
  },
  {
    "NAME": "Weissia wimmeriana",
    "DIFF": 4,
    "NOTES": "Very rare montane plant."
  },
  {
    "NAME": "Weissia condensa",
    "DIFF": 4,
    "NOTES": "Very rare plant of southern chalk and limestone."
  },
  {
    "NAME": "Weissia wilsonii",
    "DIFF": 4,
    "NOTES": "Mature capsules essential for certain ID. Not as rare as previously thought."
  },
  {
    "NAME": "Pottiopsis caespitosa",
    "DIFF": 4,
    "NOTES": "Winter annual characteristic of the best, short, chalk grassland."
  },
  {
    "NAME": "Tortella fragilis",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Tortella inclinata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Tortella fasciculata",
    "DIFF": 4,
    "NOTES": "Most plants formerly known as T. bambergeri are this species."
  },
  {
    "NAME": "Chionoloma cylindrotheca",
    "DIFF": 4,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Chionoloma hibernicum",
    "DIFF": 4,
    "NOTES": "Mainly a plant of NW Scotland and W Ireland."
  },
  {
    "NAME": "Chionoloma recurvifolium",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Leptobarbula berica",
    "DIFF": 4,
    "NOTES": "A minute and difficult species. Capsules are required for certain identification."
  },
  {
    "NAME": "Ephemerum crassinervium",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Ephemerum cohaerens",
    "DIFF": 4,
    "NOTES": "Rare species."
  },
  {
    "NAME": "Ephemerum spinulosum",
    "DIFF": 4,
    "NOTES": "Very rare species."
  },
  {
    "NAME": "Didymodon umbrosus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Didymodon icmadophilus",
    "DIFF": 4,
    "NOTES": "Much more common than D. acutus and often in more man-made habitats."
  },
  {
    "NAME": "Didymodon cordatus",
    "DIFF": 4,
    "NOTES": "Very rare plant of one site in Devon."
  },
  {
    "NAME": "Didymodon tomaculosus",
    "DIFF": 4,
    "NOTES": "Rare plant of clayey arable fields - has very distinctive rhizoidal tubers."
  },
  {
    "NAME": "Crossidium squamiferum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Pterygoneurum papillosum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Aloina brevirostris",
    "DIFF": 4,
    "NOTES": "Mature capsules essential for certain identification."
  },
  {
    "NAME": "Aloina rigida",
    "DIFF": 4,
    "NOTES": "Mature capsules essential for certain identification."
  },
  {
    "NAME": "Tortula inermis",
    "DIFF": 4,
    "NOTES": "Very rare plant - one site in Banffshire."
  },
  {
    "NAME": "Tortula cuneifolia",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Tortula solmsii",
    "DIFF": 4,
    "NOTES": "Very rare plant of SW England."
  },
  {
    "NAME": "Tortula vahliana",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Tortula canescens",
    "DIFF": 4,
    "NOTES": "Rare and mostly confined to coastal habitats in Devon and Cornwall."
  },
  {
    "NAME": "Tortula leucostoma",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Tortula cernua",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Tortula amplexa",
    "DIFF": 4,
    "NOTES": "Rare but possibly spreading slowly."
  },
  {
    "NAME": "Tortula wilsonii",
    "DIFF": 4,
    "NOTES": "Rare SW plants with strongly papillose leaf cells."
  },
  {
    "NAME": "Tortula viridifolia",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Hennediella stanfordensis",
    "DIFF": 4,
    "NOTES": "Intergrades morphologically with H. macrophylla in places."
  },
  {
    "NAME": "Hennediella macrophylla",
    "DIFF": 4,
    "NOTES": "Intergrades morphologically with H. stanfordensis in places."
  },
  {
    "NAME": "Chenia leptophylla",
    "DIFF": 4,
    "NOTES": "Rare plant."
  },
  {
    "NAME": "Syntrichia norvegica",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Syntrichia princeps",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Cinclidotus riparius",
    "DIFF": 4,
    "NOTES": "Very rare - only in the River Teme catchment."
  },
  {
    "NAME": "Saelania glaucescens",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Blindia caespiticia",
    "DIFF": 4,
    "NOTES": "Very rare plant, readily distinguished from B. acuta by capsules."
  },
  {
    "NAME": "Blindiadelphus diversifolius",
    "DIFF": 4,
    "NOTES": "Possibly not in Britain."
  },
  {
    "NAME": "Blindiadelphus campylopodus",
    "DIFF": 4,
    "NOTES": "Like S. recurvata but much rarer."
  },
  {
    "NAME": "Seligeria brevifolia",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Seligeria oelandica",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Seligeria carniolica",
    "DIFF": 4,
    "NOTES": "Very rare plant of rivers."
  },
  {
    "NAME": "Coscinodon cribrosus",
    "DIFF": 4,
    "NOTES": "Like a Grimmia but with pleated leaves."
  },
  {
    "NAME": "Schistidium agassizii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium flexipile",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Schistidium trichodon",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium papillosum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium pruinosum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium dupretii",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Schistidium robustum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium confertum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium flaccidum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Schistidium frigidum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium atrofuscum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Schistidium helveticum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Grimmia anodon",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Grimmia crinita",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Grimmia laevigata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia tergestina",
    "DIFF": 4,
    "NOTES": "Very typical of calcareous rocks especially Cotswold limestone roof tiles."
  },
  {
    "NAME": "Grimmia montana",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia reflexidens",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Grimmia alpestris",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Grimmia arenaria",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia elongata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia ovalis",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia unicolor",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Grimmia atrata",
    "DIFF": 4,
    "NOTES": "Rare plant characteristic of copper-bearing rocks."
  },
  {
    "NAME": "Grimmia incurva",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia muehlenbeckii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Grimmia anomala",
    "DIFF": 4,
    "NOTES": "Very rare plant. Clusters of globose yellowish gemmae usually present at leaf apices."
  },
  {
    "NAME": "Grimmia elatior",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Racomitrium macounii",
    "DIFF": 4,
    "NOTES": "Rare plant with a reddish tinge."
  },
  {
    "NAME": "Racomitrium affine",
    "DIFF": 4,
    "NOTES": "Separation from R. heterostichum often difficult."
  },
  {
    "NAME": "Racomitrium himalayanum",
    "DIFF": 4,
    "NOTES": "Very rare Scottish plant."
  },
  {
    "NAME": "Hedwigia striata",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Tayloria tenuis",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Paludella squarrosa",
    "DIFF": 4,
    "NOTES": "Extremely rare plant."
  },
  {
    "NAME": "Bartramia aprica",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Philonotis marchica",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Philonotis caespitosa",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Philonotis tomentella",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Philonotis seriata",
    "DIFF": 4,
    "NOTES": "Plant of montane flushes."
  },
  {
    "NAME": "Bryum marratii",
    "DIFF": 4,
    "NOTES": "Rare halophyte."
  },
  {
    "NAME": "Bryum dixonii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum gemmiferum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum gemmilucens",
    "DIFF": 4,
    "NOTES": "Rare but distinctive species."
  },
  {
    "NAME": "Bryum apiculatum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Bryum dyffrynense",
    "DIFF": 4,
    "NOTES": "Rare coastal plant."
  },
  {
    "NAME": "Bryum valparaisense",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Bryum gemmiparum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum tenuisetum",
    "DIFF": 4,
    "NOTES": "Rhizoidal tubers and rhizoids are characteristic."
  },
  {
    "NAME": "Bryum mildeanum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum muehlenbeckii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum demissum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum warneum",
    "DIFF": 4,
    "NOTES": "Rare halophyte."
  },
  {
    "NAME": "Bryum calophyllum",
    "DIFF": 4,
    "NOTES": "Rare coastal plant."
  },
  {
    "NAME": "Bryum arcticum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum uliginosum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum turbinatum",
    "DIFF": 4,
    "NOTES": "Possibly extinct."
  },
  {
    "NAME": "Bryum schleicheri",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Bryum cyclophyllum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Bryum algovicum",
    "DIFF": 4,
    "NOTES": "Not reliably recognisable without capsules."
  },
  {
    "NAME": "Bryum salinum",
    "DIFF": 4,
    "NOTES": "Rare coastal plant."
  },
  {
    "NAME": "Bryum knowltonii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum archangelicum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum intermedium",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Bryum creberrimum",
    "DIFF": 4,
    "NOTES": "Not reliably recognisable without capsules."
  },
  {
    "NAME": "Bryum bornholmense",
    "DIFF": 4,
    "NOTES": "Rhizoidal tubers and rhizoids are characteristic."
  },
  {
    "NAME": "Mielichhoferia mielichhoferiana",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Pohlia crudoides",
    "DIFF": 4,
    "NOTES": "Very rare plant - possibly extinct."
  },
  {
    "NAME": "Pohlia obtusifolia",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Pohlia scotica",
    "DIFF": 4,
    "NOTES": "Rare Scottish plant."
  },
  {
    "NAME": "Pohlia andalusica",
    "DIFF": 4,
    "NOTES": "Rare on china clay and metalliferous mine waste in south."
  },
  {
    "NAME": "Pohlia bulbifera",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Pohlia proligera",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Mnium spinosum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Mnium thomsonii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Mnium lycopodioides",
    "DIFF": 4,
    "NOTES": "Rare Scottish plant."
  },
  {
    "NAME": "Mnium marginatum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Plagiomnium medium",
    "DIFF": 4,
    "NOTES": "Rare Scottish plant."
  },
  {
    "NAME": "Plagiomnium ellipticum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Zygodon gracilis",
    "DIFF": 4,
    "NOTES": "Very rare Yorkshire plant."
  },
  {
    "NAME": "Orthotrichum columbicum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Orthotrichum scanicum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Orthotrichum rogeri",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Orthotrichum pallens",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Orthotrichum pumilum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Orthotrichum schimperi",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Orthotrichum cambrense",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Orthotrichum alpestre",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Orthotrichum patens",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Lewinskya acuminata",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Nyholmiella gymnostoma",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Nyholmiella obtusifolia",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Orthodontium gracile",
    "DIFF": 4,
    "NOTES": "Mature capsules essential for certain ID."
  },
  {
    "NAME": "Leptotheca gaudichaudii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Calomnion complanatum",
    "DIFF": 4,
    "NOTES": "Very rare introduction."
  },
  {
    "NAME": "Achrophyllum dentatum",
    "DIFF": 4,
    "NOTES": "Very rare introduction."
  },
  {
    "NAME": "Platydictya jungermannioides",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Plagiothecium latebricola",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Plagiothecium piliferum",
    "DIFF": 4,
    "NOTES": "Probably extinct."
  },
  {
    "NAME": "Plagiothecium platyphyllum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Isopterygiopsis muelleriana",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Isopterygiopsis pulchella",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Herzogiella striatella",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Habrodon perpusillus",
    "DIFF": 4,
    "NOTES": "Rare and highly pollution-sensitive epiphyte perhaps increasing."
  },
  {
    "NAME": "Cratoneuron curvicaule",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Campylium bambergeri",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Conardia compacta",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Drepanocladus polygamus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Drepanocladus sendtneri",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Drepanocladus turgescens",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Hygrohypnum styriacum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Platyhypnum smithii",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Platyhypnum molle",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Platyhypnum duriusculum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Serpoleskea confervoides",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Pseudocampylium radicale",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Hygrohypnella polaris",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Lescuraea incurvata",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Lescuraea saxicola",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Pseudoleskeella catenulata",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Pseudoleskeella rupestris",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Pseudoleskeella nervosa",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Thuidium recognitum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Plasteurhynchium meridionale",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Rhynchostegium rotundifolium",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Rhynchostegiella curviseta",
    "DIFF": 4,
    "NOTES": "R. tenerrifae/curviseta are not always morphologically distinct in SW England."
  },
  {
    "NAME": "Sciuro-hypnum starkei",
    "DIFF": 4,
    "NOTES": "Rare montane species."
  },
  {
    "NAME": "Sciuro-hypnum glaciale",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Sciuro-hypnum reflexum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Brachythecium erythrorrhizon",
    "DIFF": 4,
    "NOTES": "Possibly extinct."
  },
  {
    "NAME": "Brachythecium cirrosum",
    "DIFF": 4,
    "NOTES": "Rare montane species."
  },
  {
    "NAME": "Eurhynchiastrum diversifolium",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Brachytheciastrum trachypodium",
    "DIFF": 4,
    "NOTES": "Very rare montane plant."
  },
  {
    "NAME": "Hypnum cupressiforme var. heseleri",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Hypnum uncinulatum",
    "DIFF": 4,
    "NOTES": "Rare plant, restricted to SW Ireland."
  },
  {
    "NAME": "Stereodon callichrous",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Stereodon hamulosus",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Pseudohygrohypnum subeugyrium",
    "DIFF": 4,
    "NOTES": "Similar to P. eugyrium - needs microscope checking."
  },
  {
    "NAME": "Homomallium incurvatum",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Roaldia revoluta",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Buckia vaucheri",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Pseudostereodon procerrimus",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Neckera pennata",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Thamnobryum maderense",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Thamnobryum angustifolium",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Thamnobryum cataractarum",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Pseudanomodon attenuatus",
    "DIFF": 4,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Heterocladiella dimorpha",
    "DIFF": 4,
    "NOTES": "Rare Scottish plant."
  },
  {
    "NAME": "Anomodon longifolius",
    "DIFF": 4,
    "NOTES": ""
  },
  {
    "NAME": "Riccia nigrella",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Riccia crozalsii",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Riccia bifurca",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Dumortiera hirsuta",
    "DIFF": 5,
    "NOTES": "Relatively straightforweard to identify in the field, but very rare and not often recorded, so any potential record needs expert verification."
  },
  {
    "NAME": "Fossombronia mittenii",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Radula holtii",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Radula carringtonii",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Lejeunea hibernica",
    "DIFF": 5,
    "NOTES": "Very rare, Ireland only."
  },
  {
    "NAME": "Lejeunea eckloniana",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Lejeunea mandonii",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Herbertus norenus",
    "DIFF": 5,
    "NOTES": ""
  },
  {
    "NAME": "Tricholepidozia tetradactyla",
    "DIFF": 5,
    "NOTES": "Very rare introduction."
  },
  {
    "NAME": "Tricholepidozia lindenbergii",
    "DIFF": 5,
    "NOTES": "Very rare introduction."
  },
  {
    "NAME": "Lophocolea brookwoodiana",
    "DIFF": 5,
    "NOTES": "Very rare introduction."
  },
  {
    "NAME": "Heteroscyphus fissistipus",
    "DIFF": 5,
    "NOTES": "Ver rare ntroduction."
  },
  {
    "NAME": "Plagiochila porelloides var. norvegica",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Acrobolbus wilsonii",
    "DIFF": 5,
    "NOTES": "Rare, hyperoceanic."
  },
  {
    "NAME": "Geocalyx graveolens",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Southbya tophacea",
    "DIFF": 5,
    "NOTES": ""
  },
  {
    "NAME": "Southbya nigrella",
    "DIFF": 5,
    "NOTES": ""
  },
  {
    "NAME": "Mesoptychia rutheana",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Mesoptychia gillmanii",
    "DIFF": 5,
    "NOTES": "Rare."
  },
  {
    "NAME": "Liochlaena lanceolata",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Jungermannia polaris",
    "DIFF": 5,
    "NOTES": "Rare."
  },
  {
    "NAME": "Nardia insecta",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Marsupella apiculata",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Marsupella arctica",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Marsupella profunda",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Marsupella sparsifolia",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Marsupella boeckii",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Adelanthus lindenbergianus",
    "DIFF": 5,
    "NOTES": "Very rare and hyperoceanic, but distinctive."
  },
  {
    "NAME": "Cephalozia ambigua",
    "DIFF": 5,
    "NOTES": "Snow patch vegetation only."
  },
  {
    "NAME": "Biantheridion undulifolium",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Cephaloziella spinigera",
    "DIFF": 5,
    "NOTES": ""
  },
  {
    "NAME": "Cephaloziella elachista",
    "DIFF": 5,
    "NOTES": ""
  },
  {
    "NAME": "Cephaloziella massalongoi",
    "DIFF": 5,
    "NOTES": "Very rare heavy metal specialist."
  },
  {
    "NAME": "Cephaloziella nicholsonii",
    "DIFF": 5,
    "NOTES": "Very rare heavy metal specialist."
  },
  {
    "NAME": "Cephaloziella dentata",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Cephaloziella calyculata",
    "DIFF": 5,
    "NOTES": "Rare."
  },
  {
    "NAME": "Protolophozia herzogiana",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Lophozia guttulata",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Lophozia wenzelii",
    "DIFF": 5,
    "NOTES": "Very obscure in Britain, and not certain if it really occurs here."
  },
  {
    "NAME": "Scapania praetervisa",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Scapania parvifolia",
    "DIFF": 5,
    "NOTES": "Very rare."
  },
  {
    "NAME": "Sphagnum balticum",
    "DIFF": 5,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Sphagnum obtusum",
    "DIFF": 5,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Dicranoloma menziesii",
    "DIFF": 5,
    "NOTES": "Very rare introduction."
  },
  {
    "NAME": "Bruchia vogesiaca",
    "DIFF": 5,
    "NOTES": "Likely extinct."
  },
  {
    "NAME": "Trematodon ambiguus",
    "DIFF": 5,
    "NOTES": "Likely extinct."
  },
  {
    "NAME": "Ceratodon conicus",
    "DIFF": 5,
    "NOTES": "Rare plant. Identification without capsules may not be reliable."
  },
  {
    "NAME": "Tortella pseudofragilis",
    "DIFF": 5,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Gyroweisia reflexa",
    "DIFF": 5,
    "NOTES": "Probably extinct."
  },
  {
    "NAME": "Leptodontium proliferum",
    "DIFF": 5,
    "NOTES": "Very rare introduced plant."
  },
  {
    "NAME": "Didymodon maximus",
    "DIFF": 5,
    "NOTES": "Very rare, often robust plants. Only in W. Ireland."
  },
  {
    "NAME": "Didymodon australasiae",
    "DIFF": 5,
    "NOTES": "Very rare plant."
  },
  {
    "NAME": "Didymodon glaucus",
    "DIFF": 5,
    "NOTES": "Tiny plant restricted to one site in Wiltshire."
  },
  {
    "NAME": "Didymodon acutus",
    "DIFF": 5,
    "NOTES": "Very rare plant; very similar to D. icmadophilus."
  },
  {
    "NAME": "Pterygoneurum lamellatum",
    "DIFF": 5,
    "NOTES": "Likely extinct."
  },
  {
    "NAME": "Aplodon wormskioldii",
    "DIFF": 5,
    "NOTES": "Possibly extinct."
  },
  {
    "NAME": "Meesia triquetra",
    "DIFF": 5,
    "NOTES": "Likely extinct."
  },
  {
    "NAME": "Lewinskya shawii",
    "DIFF": 5,
    "NOTES": "Probably extinct."
  },
  {
    "NAME": "Microhypnum sauteri",
    "DIFF": 5,
    "NOTES": "Very rare plant - only recently discovered in Scotland."
  },
  {
    "NAME": "Helodium blandowii",
    "DIFF": 5,
    "NOTES": "Extinct."
  }
]